



















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import Modal from '@/shared/components/Modal/Modal.vue';
import CompleteRegister from './CompleteRegister.vue';

import { ICustomer } from '@/interfaces/Customer';

const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    CompleteRegister,
    Modal
  }
})
export default class CompleteRegisterModal extends Vue {
  private completed = false;

  @CustomerModule.State(state => state.customer)
  private customer: ICustomer;

  @Watch('completed')
  onCompletedChange (value: boolean) {
    value && this.$emit('completed');
  }
}
